import styled from '@emotion/styled';
import { Button, ButtonProps } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

interface UploadButtonProps {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  required?: boolean;
}
export const UploadButton: FC<
  PropsWithChildren<
    UploadButtonProps & Pick<
      ButtonProps, 'sx' | 'component' | 'variant' | 'startIcon'
    >
  >
> = ({onChange, name, required, children, ...buttonProps}) => (
  <Button
    {...buttonProps}
    role="button"
    tabIndex={-1}
  >
    {children}
    <VisuallyHiddenInput
      type="file"
      name={name}
      required={required}
      onChange={onChange}
    />
  </Button>
);
